import "./index.css";
import privacyCover from "../../Assets/privacy/privacyBackground.webp";
import privacyBackground from "../../Assets/privacy/privacyCover.webp";
import Footer from "../../Layouts/Footer";
import Logo from "../../Assets/Logo/Logo.png";
import Fade from "react-reveal/Fade";

export default function PrivacyPolicy() {
	return (
		<div className="w-100">
			<div
				className="Privacy-cover"
				style={{
					// background: "#4D917E",
					// paddingTop: "2rem",
					backgroundImage: `url(${privacyCover})`,
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "top",

					// display: "flex",
					// alignItems: "center",
					// justifyContent: "space-around",
					// backgroundPosition: "right top",
				}}
			>
				<Fade bottom>
					<h1>ПОЛИТИКА КОНФЕДИЦИАЛЬНОСТИ</h1>
				</Fade>
			</div>

			<div className="privacy-policy ">
				<p>
					Настоящая Политика конфиденциальности персональных данных (далее -
					Политика конфиденциальности) является неотъемлемой частью
					Пользовательского соглашения, размещенного на сайте в сети Интернет по
					адресу: https://elarteclinic.com/user-agreement (далее - Сайт).
				</p>
				<p>
					Использование сервисов Сайта означает безоговорочное согласие
					Пользователя с настоящей Политикой и указанными в ней условиями
					обработки его персональной информации; в случае несогласия с этими
					условиями Пользователь должен воздержаться от использования сервисов.
				</p>
				<p>1. ОБЩИЕ ПОЛОЖЕНИЯ</p>
				<p>
					1.1. В рамках настоящей Политики под персональной информацией
					Пользователя понимаются:
				</p>
				<p>
					1.1.1. Персональная информация, которую Пользователь предоставляет о
					себе самостоятельно при регистрации (создании учетной записи) или в
					процессе использования Сервисов, включая персональные данные
					Пользователя. Обязательная для предоставления Сервисов информация
					помечена специальным образом.
				</p>
				<p>
					1.1.2. Данные, которые автоматически передаются сервисам Сайта в
					процессе их использования с помощью установленного на устройстве
					Пользователя программного обеспечения, в том числе IP-адрес, данные
					файлов cookie, информация о браузере Пользователя (или иной программе,
					с помощью которой осуществляется доступ к сервисам), технические
					характеристики оборудования и программного обеспечения, используемых
					Пользователем, дата и время доступа к сервисам, адреса запрашиваемых
					страниц и иная подобная информация.
				</p>
				<p>
					1.1.3. Настоящая Политика конфиденциальности применяется только к
					Сайту https://elarteclinic.com. Сайт https://elarteclinic.com не
					контролирует и не несет ответственности за сайты третьих лиц, на
					которые Пользователь может перейти по ссылкам, доступным на Сайте.
				</p>
				<p>2. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЕЙ</p>
				<p>
					2.1. Сайт собирает и хранит только ту персональную информацию, которая
					необходима для предоставления сервисов или исполнения соглашений и
					договоров с Пользователем, за исключением случаев, когда
					законодательством предусмотрено обязательное хранение персональной
					информации в течение определенного законом срока.
				</p>
				<p>
					В случае получения уведомления от Пользователя об отзыве согласия на
					обработку персональных данных Сайт прекращает обработку персональных
					данных Пользователя в срок, не превышающий 10 рабочих дней с момента
					получения.
				</p>
				<p>
					Уведомление об отзыве согласия на обработку персональных данных
					направляется на адрес электронной почты: info@elarteclinic.com.
				</p>
				<p>
					2.2. Персональную информацию Пользователя Сайт обрабатывает в
					следующих целях:
				</p>
				<p>
					2.2.1. Обработки заявки, оставленной Пользователем, и предоставления
					ему консультации.
				</p>
				<p>
					2.2.2. Предоставления Пользователю доступа к персонализированным
					ресурсам Сайта.
				</p>
				<p>
					2.2.3. Установления с Пользователем обратной связи, включая
					направление уведомлений, запросов, касающихся использования Сайта,
					оказания услуг, обработку запросов и заявок от Пользователя.
				</p>
				<p>
					2.2.4. Определения места нахождения Пользователя для обеспечения
					безопасности, предотвращения мошенничества.
				</p>
				<p>
					2.2.5. Подтверждения достоверности и полноты персональных данных,
					предоставленных Пользователем.
				</p>
				<p>
					2.2.6. Предоставления Пользователю эффективной клиентской и
					технической поддержки при возникновении проблем, связанных с
					использованием Сайта.
				</p>
				<p>2.2.7. Осуществление рекламных рассылок с согласия Пользователя.</p>
				<p>3. УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЕЙ</p>
				<p>И ЕЕ ПЕРЕДАЧИ ТРЕТЬИМ ЛИЦАМ</p>
				<p>
					3.1. Сайт хранит персональную информацию Пользователей в соответствии
					с внутренними регламентами конкретных сервисов.
				</p>
				<p>
					3.2. В отношении персональной информации Пользователя сохраняется ее
					конфиденциальность, кроме случаев добровольного предоставления
					Пользователем информации о себе для общего доступа неограниченному
					кругу лиц. При использовании отдельных сервисов Пользователь
					соглашается с тем, что определенная часть его персональной информации
					становится общедоступной.
				</p>
				<p>
					3.3. Сайт вправе передать персональную информацию Пользователя третьим
					лицам в следующих случаях:
				</p>
				<p>3.3.1. Пользователь выразил согласие на такие действия.</p>
				<p>
					3.3.2. Передача необходима для использования Пользователем
					определенного сервиса либо для исполнения определенного соглашения или
					договора с Пользователем.
				</p>
				<p>
					3.3.4. Передача предусмотрена российским или иным применимым
					законодательством в рамках установленной законодательством процедуры.
				</p>
				<p>
					3.3.5. В случае продажи Сайта к приобретателю переходят все
					обязательства по соблюдению условий настоящей Политики применительно к
					полученной им персональной информации.
				</p>
				<p>
					3.4. Обработка персональных данных Пользователя осуществляется без
					ограничения срока следующими способами: сбор, запись, систематизация,
					накопление, хранение, уточнение (обновление, изменение), извлечение,
					использование, передача (распространение, предоставление, доступ),
					обезличивание, блокирование, удаление, уничтожение персональных
					данных, в том числе в информационных системах персональных данных с
					использованием средств автоматизации или без использования таких
					средств. Обработка персональных данных Пользователей осуществляется в
					соответствии с Федеральным законом от 27.07.2006 N 152-ФЗ "О
					персональных данных".
				</p>
				<p>
					3.5. При утрате или разглашении персональных данных Администрация
					Сайта информирует Пользователя об утрате или разглашении персональных
					данных.
				</p>
				<p>
					3.6. Администрация Сайта принимает необходимые организационные и
					технические меры для защиты персональной информации Пользователя от
					неправомерного или случайного доступа, уничтожения, изменения,
					блокирования, копирования, распространения, а также от иных
					неправомерных действий третьих лиц.
				</p>
				<p>
					3.7. Администрация Сайта совместно с Пользователем принимает все
					необходимые меры по предотвращению убытков или иных отрицательных
					последствий, вызванных утратой или разглашением персональных данных
					Пользователя.
				</p>
				<p>4. ОБЯЗАТЕЛЬСТВА СТОРОН</p>
				<p>4.1. Пользователь обязан:</p>
				<p>
					4.1.1. Предоставить информацию о персональных данных, необходимую для
					пользования Сайтом.
				</p>
				<p>
					4.1.2. Обновлять, дополнять предоставленную информацию о персональных
					данных в случае изменения данной информации.
				</p>
				<p>4.2. Администрация Сайта обязана:</p>
				<p>
					4.2.1. Использовать полученную информацию исключительно для целей,
					указанных в настоящей Политике конфиденциальности.
				</p>
				<p>
					4.2.2. Обеспечить хранение конфиденциальной информации в тайне, не
					разглашать без предварительного письменного разрешения Пользователя, а
					также не осуществлять продажу, обмен, опубликование либо разглашение
					иными возможными способами переданных персональных данных
					Пользователя, за исключением предусмотренных настоящей Политикой
					конфиденциальности.
				</p>
				<p>
					4.2.3. Осуществить блокирование персональных данных, относящихся к
					соответствующему Пользователю, с момента обращения или запроса
					Пользователя или его законного представителя либо уполномоченного
					органа по защите прав субъектов персональных данных на период проверки
					в случае выявления недостоверных персональных данных или неправомерных
					действий.
				</p>
				<p>5. ОТВЕТСТВЕННОСТЬ СТОРОН</p>
				<p>
					5.1. Администрация Сайта, не исполнившая свои обязательства, несет
					ответственность за убытки, понесенные Пользователем в связи с
					неправомерным использованием персональных данных, в соответствии с
					законодательством Российской Федерации.
				</p>
				<p>
					5.2. В случае утраты или разглашения конфиденциальной информации
					Администрация Сайта не несет ответственности, если данная
					конфиденциальная информация:
				</p>
				<p>5.2.1. Стала публичным достоянием до ее утраты или разглашения.</p>
				<p>
					5.2.2. Была получена от третьей стороны до момента ее получения
					Администрацией Сайта.
				</p>
				<p>5.2.3. Была разглашена с согласия Пользователя.</p>
				<p>6. РАЗРЕШЕНИЕ СПОРОВ</p>
				<p>
					6.1. До обращения в суд с иском по спорам, возникающим из отношений
					между Пользователем Сайта и Администрацией Сайта, обязательным
					является предъявление претензии (письменного предложения о
					добровольном урегулировании спора).
				</p>
				<p>
					6.2. Получатель претензии в течение 14 календарных дней со дня
					получения претензии письменно уведомляет заявителя претензии о
					результатах рассмотрения претензии.
				</p>
				<p>
					6.3. При недостижении соглашения спор будет передан на рассмотрение в
					суд в соответствии с действующим законодательством Российской
					Федерации.
				</p>
				<p>
					6.4. К настоящей Политике конфиденциальности и отношениям между
					Пользователем и Администрацией Сайта применяется действующее
					законодательство Российской Федерации.
				</p>
				<p>7. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</p>
				<p>
					7.1. Администрация Сайта вправе вносить изменения в настоящую Политику
					конфиденциальности без согласия Пользователя.
				</p>
				<p>
					7.2. Новая Политика конфиденциальности вступает в силу с момента ее
					размещения на Сайте, если иное не предусмотрено новой редакцией
					Политики конфиденциальности.
				</p>
				<p>
					7.4. Действующая Политика конфиденциальности размещена на странице по
					адресу: https://elarteclinic.com/privacy
				</p>
				<p>
					7.5. Настоящая Политика конфиденциальности является неотъемлемой
					частью Пользовательского соглашения, размещенного на странице по
					адресу: https://elarteclinic.com/user-agreement
				</p>
			</div>
			<div
				className="Privacy-logo"
				style={{
					// background: "#4D917E",
					// paddingTop: "2rem",
					backgroundImage: `url(${privacyBackground})`,
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "bottom",

					// display: "flex",
					// alignItems: "center",
					// justifyContent: "space-around",
					// backgroundPosition: "right top",
				}}
			>
				<img
					className="privacy-logo-left"
					src={Logo}
					alt={decodeURIComponent(Logo.split("/").pop().split(".")[0])}
				></img>
			</div>
			<Footer />
		</div>
	);
}
